// The site-visit slots offered inside the call: the three days after the meeting's own day, at 11:00 and 16:00 in
// India's time. One list for the customer's screen and for the back end that checks her booking against it, so a
// booking is always a real date and time the studio offered, never a label typed in a browser (audit F2, CV3).
// It depends only on the meeting's start, so the screen and the server always agree.
export const VISIT_TIMES = ["11:00", "16:00"];
const IST_MIN = 330;

export function visitSlots(startsAt) {
  const t = Date.parse(startsAt);
  if (!Number.isFinite(t)) return [];
  const ist = new Date(t + IST_MIN * 60_000); // the meeting's calendar day in India
  const label = new Intl.DateTimeFormat("en-IN", { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" });
  const out = [];
  for (let k = 1; k <= 3; k++) {
    const day = new Date(Date.UTC(ist.getUTCFullYear(), ist.getUTCMonth(), ist.getUTCDate() + k));
    const date = day.toISOString().slice(0, 10);
    for (const time of VISIT_TIMES) out.push({ date, time, at: `${date}T${time}:00+05:30`, day: label.format(day).replace(",", "") });
  }
  return out;
}

// The slots still ahead: a link lives a day past the meeting, and a slot that has gone by is neither shown nor booked.
export function openSlots(startsAt, now = Date.now()) {
  return visitSlots(startsAt).filter((s) => Date.parse(s.at) > now);
}
